import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { BaseProvider } from 'what-di/lib/base-provider';
import DefaultContainer from "./DefaultContainer";
import { defaultInit } from "./uedHelper";
export var UedProvider = /*#__PURE__*/function (_BaseProvider) {
  _inherits(UedProvider, _BaseProvider);
  var _super = _createSuper(UedProvider);
  function UedProvider() {
    var _this;
    _classCallCheck(this, UedProvider);
    _this = _super.call(this);
    _this.setState({
      Container: DefaultContainer,
      initFunction: defaultInit
    });
    return _this;
  }
  _createClass(UedProvider, [{
    key: "registerContainer",
    value: function registerContainer(Container) {
      this.setState(_objectSpread({}, this.state, {
        Container: Container
      }));
    }
  }, {
    key: "Container",
    get: function get() {
      return this.state.Container;
    }
  }]);
  return UedProvider;
}(BaseProvider);